import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ContactForm } from '../components/ContactForm';
import { usePageMeta } from '../utils/usePageMeta';
import { Eyebrow } from '../components/Eyebrow';

export const Contact: React.FC = () => {
  usePageMeta({
    title: 'Contact Us - Partnerships & Samples | Lot 20 Coffee',
    description: 'Get in touch with Lot 20 Coffee. Inquire about coffee samples, partnerships, decaf services, or nursery operations. We respond within 24 hours.',
    canonicalPath: '/contact'
  });

  const [searchParams] = useSearchParams();
  const [initialData, setInitialData] = useState<{coffee?: string; subject?: string}>({});

  useEffect(() => {
    const coffee = searchParams.get('coffee');
    const subject = searchParams.get('subject');
    if (coffee || subject) {
      setInitialData({ coffee, subject });
    }
  }, [searchParams]);

  return (
    <>
      {/* Header */}
      <section className="pt-3 pb-16 bg-[#FAFAF8]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <Eyebrow className="mb-3">Get In Touch</Eyebrow>
          <h1 className="font-display text-4xl md:text-5xl text-[#404040] mb-4">
            Connect With Us
          </h1>
          <p className="font-display text-lg text-[#6B6B6B] max-w-2xl">
            Ready to partner with us? Get in touch for samples, partnerships, or general inquiries.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="pb-24 md:pb-32 bg-[#FAFAF8]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-[1fr_360px] gap-16 lg:gap-24 items-start">
            <ContactForm initialData={initialData} />

            <div className="space-y-8">
              <div className="border border-[#E8E6E2] p-8">
                <Eyebrow className="mb-4">Visit Our Lab</Eyebrow>
                <address className="not-italic space-y-1 mb-4">
                  <p className="text-sm font-medium text-[#404040]">Lot 20 Coffee</p>
                  <p className="text-sm text-[#6B6B6B]">Nandi Hills Lab</p>
                </address>
                <p className="font-display text-sm text-[#6B6B6B] mb-3">
                  Send email to book an appointment
                </p>
                <a href="mailto:sidney@lot20.coffee" className="text-sm text-[#404040] font-medium hover:text-[#E85C27] transition-colors duration-300">
                  sidney@lot20.coffee
                </a>
              </div>

              <div className="border border-[#E8E6E2] p-8">
                <Eyebrow className="mb-4">Response Times</Eyebrow>
                <div className="space-y-3">
                  {[
                    { type: 'Sample requests', time: '1-2 business days' },
                    { type: 'Partnership inquiries', time: 'Same day' },
                    { type: 'Technical questions', time: 'Within hours' },
                  ].map(item => (
                    <div key={item.type} className="flex justify-between items-baseline">
                      <span className="text-sm text-[#6B6B6B]">{item.type}</span>
                      <span className="text-sm text-[#404040]">{item.time}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
